import React from "react";
import styled from "styled-components";
import { CardHeading } from "../../Card";
export const PanelHeader = (props) => {
    const { title, titleIcon } = props;
    return React.createElement(Heading, { iconSrc: titleIcon }, title);
};
const Heading = styled(CardHeading) `
  margin-bottom: ${(props) => `${props.theme.space[3]}px`};
`;
